module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/207/assets/images/71d183cc6ae20a3e5fc69388fe012b53.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/ico_lightning_bolt.svg
// module id = uPEL
// module chunks = 1